import { render, staticRenderFns } from "./CornerRibbon.vue?vue&type=template&id=630a80de&"
import script from "./CornerRibbon.vue?vue&type=script&lang=ts&"
export * from "./CornerRibbon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports